import React from 'react';
import styled from 'styled-components';
import { SwiperSlide } from 'swiper/react';
import { IFavoritedAnalysisFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import Carousel from '../../../components/Carousel';
import FavoritedReport from './FavoritedReport';
import FavoritedReportsEmptySlide from './FavoritedReportsEmptySlide';

interface IProps {
  entities: IFavoritedAnalysisFieldsFragment[];
}

const StyledSlide = styled(SwiperSlide)`
  height: 300px;
`;

const FavoritedReportsSlider = ({ entities }: IProps) => {
  return (
    <Carousel
      spaceBetween={12}
      slidesPerView={Math.min(entities.length + 1, 3.5)}
    >
      {entities.map((entity) => (
        <StyledSlide key={entity.id}>
          <FavoritedReport analysisId={entity.id} display={entity.display} />
        </StyledSlide>
      ))}
      <StyledSlide>
        <FavoritedReportsEmptySlide />
      </StyledSlide>
    </Carousel>
  );
};

export default FavoritedReportsSlider;
